const food = [
    {
        id:1,
        name: 'english breakfast',
        price: '14.00'
    },
    {
        id:2,
        name: 'spaghetti carbonara',
        price: '11.00'
    },
    {
        id:3,
        name: 'spicy beef',
        price: '17.00'
    }
];

export default food;